import _ from 'lodash';
import { IncludesProductOptionsType, ProductKeysType } from '../model';
import { BITBUCKET, OPSGENIE, PRODUCT_NAMES } from './constants';

/**
 * Given Product Key, return Product name
 */

export const getProductNameFromKey = (productKey: string): string => {
  const nameIdx = PRODUCT_NAMES.map((name: string) =>
    name.toLowerCase()
  ).findIndex((productName) => productKey.includes(productName));
  return nameIdx === -1 ? '' : PRODUCT_NAMES[nameIdx];
};

/**
 * Check for a matching productName within products
 */

export const includesProduct = ({
  products,
  productName
}: IncludesProductOptionsType): boolean => {
  return products.some(({ product: productKey }) => {
    if (typeof productKey !== 'string') {
      return false;
    }
    return getProductNameFromKey(productKey) === productName;
  });
};

export const onProductsRequireSitename = (productKeys: ProductKeysType[]) => {
  return productKeys
    .map(({ product: productKey }) => productKey)
    .map(getProductNameFromKey)
    .some((productName: string) => [BITBUCKET, OPSGENIE].includes(productName));
};
